import usePreventer from './usePreventer';

export { ToggleContextProvider } from './usePreventer';

export default usePreventer;
